import React from "react";
import { Badge, darken, Typography } from "@mui/material";
import clsx from "clsx";

import { useTheme } from "@mui/styles";
import { TagBadgeProps } from "../exercise-library/ExerciseTagBadge";
import { exerciseLibraryStyles } from "../exercise-library/exerciseLibraryStyles";
import { ClientTagMultiSelect } from "./ClientTagMultiSelect";
import TagChip from "../exercise-library/tags/TagChip";

interface ClientTagBadgeProps extends TagBadgeProps {
  clientId?: number;
}

export const ClientTagBadge: React.FC<ClientTagBadgeProps> = ({
  selectedTags,
  open,
  setOpen,
  anchorEl,
  setAnchorEl,
  clientId,
  showDashWhenEmpty = true,
  classes,
  readonly = false,
}) => {
  const s = exerciseLibraryStyles();
  const theme = useTheme();
  const first = selectedTags && selectedTags[0];

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (readonly) {
      return;
    }
    setOpen && setOpen(true);
    setAnchorEl && setAnchorEl(e.currentTarget);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <>
      {first ? (
        <Badge
          badgeContent={
            selectedTags.length > 1 ? `+${selectedTags.length - 1}` : null
          }
          invisible={selectedTags.length <= 1}
          className={classes?.badge}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: darken(
                first?.primaryColor || theme.palette.primary.main,
                0.2,
              ),
              color: theme.palette.common.white,
            },
          }}
        >
          <TagChip
            primaryColor={first.primaryColor}
            text={first.title}
            className={clsx(classes?.category, s.badgeCategoryTag)}
            onClick={handleClick}
          />
        </Badge>
      ) : showDashWhenEmpty ? (
        <Typography
          onClick={handleClick}
          sx={{
            cursor: "pointer",
            paddingY: 2,
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          -
        </Typography>
      ) : null}

      <ClientTagMultiSelect
        open={open}
        setOpen={setOpen}
        anchorEl={anchorEl}
        clientId={clientId}
        onClose={() => {
          setOpen && setOpen(false);
          setAnchorEl && setAnchorEl(null);
        }}
        initialSelected={selectedTags}
        showButton={false}
        readonly={readonly}
      />
    </>
  );
};
